import { Button, ButtonProps } from "@kaltura/ds-react-components";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * replace media link to be used on conversion error
 *
 */
export const ReplaceMediaAction = (props: ButtonProps) => {
    const { href, size, children } = props;

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = () => {
        sendButtonAnalytics("Media Hero - Upload again", ButtonClickAnalyticsType.ADD);
    };

    return (
        <Button component={"a"} size={size} href={href} onClick={sendAnalytics}>
            {children}
        </Button>
    );
};
export default ReplaceMediaAction;
